import { FacilityResolved, SensorIdMap } from '../../features/AssetGrid/types/facility.types';
import { addNamespace } from '../../features/AssetGrid/utils/actions';
import { createAction } from '@reduxjs/toolkit';

export const getFacility = createAction<string>(
	addNamespace('facility/getFacility'),
);
export const getFacilityResolved = createAction<FacilityResolved>(
	addNamespace('facility/getFacility/resolved'),
);
export const clearFacilities = createAction(
	addNamespace('facility/facilityList/clear'),
);
export const setSensorIdsMap = createAction<SensorIdMap[]>(
	addNamespace('facility/setSensorIdsMap/resolved'),
);
export const clearSensorIdsMap = createAction(
	addNamespace('facility/clearSensorIdsMap/resolved'),
);
